import { Component } from '@angular/core';
import { Dashboard, LoginService } from '../../../services/login-service';
import { RouterService } from '../../utility/router-service';


@Component({
  selector: 'app-dashboards',
  standalone: false,
  templateUrl: './dashboards.component.html',
  styleUrl: './dashboards.component.css'
})
export class DashboardsComponent {
  public selectedDashboard: Dashboard;
  public selectedId: string;
  constructor(public loginService: LoginService, private routerService: RouterService) {
    this.selectedDashboard = loginService.user.dashboards[0];
    this.selectedId = this.selectedDashboard.dashboardId.toString();
  }

  setSelectedDashboard(d: Dashboard) {
    this.selectedDashboard = d;
    this.selectedId = this.selectedDashboard.dashboardId.toString();
  }

  gridMenu = [
    { id: 'view', label: 'View / Edit' }
  ];
  onGridMenu(e: { id: string; row: Record<string, any> }) {
    switch (e.id) {
      case 'view':
        if (e.row) {
          this.routerService.router.navigate([
            '/data-explorer',
            e.row["ClientId"],
            e.row["TableSchema"],
            e.row["TableName"],
            e.row["Id"]
          ], {
            queryParams: {
              dataSetId: e.row["DataSetId"]
            }
          });
        }
        break;
    }
  }
}
